import { viewFeedbackAnswerState } from '../state/viewFeedbackAnswerState';
import { ANSWER_LIST_REQUEST, ANSWER_LIST_SUCCESS,UPDATED_ALARM_STATUS_LIST_SUCCESS1 } from '../actions/viewFeedbackAnswerAction';

var initialStatusCode = '';

export function viewFeedbackAnswerReducer(state = viewFeedbackAnswerState, action) {
    switch (action.type) {
        case UPDATED_ALARM_STATUS_LIST_SUCCESS1:
                    return Object.assign({}, state, {
                        isLoading: action.isLoading,
                        alarmReceiverList: action.list,
                        errorCode: action.errorCode,
                        messageLabel: action.message, 
                        statusCode: action.statusCode
                    })
        case ANSWER_LIST_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading
            })
        case ANSWER_LIST_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                answerList: action.list,
                errorCode: action.errorCode,
                messageLabel: action.message, 
                statusCode: action.statusCode
            })
        default:
            return state;
    }
}
